// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".paid-member-price[data-v-472cca20] .caption{background-color:#94bfe3}", ""]);
// Exports
module.exports = exports;
